import {
  Message
} from 'element-ui'
import {
  errorCode
} from '@/config'

export function formatTime(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0' + m : m + ''
  s = s < 10 ? '0' + s : s + ''
  return m + ':' + s
}
export function isJzjx() {
  return /JZJX_Android/i.test(navigator.userAgent)
}
export function htmlEncodeByRegExp(str) {
  let s = "";
  if (str.length == 0) return "";
  s = str.replace(/&/g, "&amp;");
  s = s.replace(/</g, "&lt;");
  s = s.replace(/>/g, "&gt;");
  s = s.replace(/ /g, "&nbsp;");
  s = s.replace(/\'/g, "&#39;");
  s = s.replace(/\"/g, "&quot;");
  return s;
}
export function htmlDecodeByRegExp(str) {
  let s = '', repNum = 0;
  if(str){
    if (str.length === 0) return ''
    s = str.replace(/&amp;/g,"&")
    s = s.replace(/&lt;/g," < ")
    s = s.replace(/&gt;/g," > ")
    s = s.replace(/\\&nbsp;/g," ")  // 修复公式\\后面有&nbsp;
    s = s.replace(/&nbsp;/g," ")
    s = s.replace(/<br\/>/g,"")
    s = s.replace(/<stong\/>/g,"")
    s = s.replace(/&#39;/g,"\'")
    s = s.replace(/&quot;/g,"\"")
    s = s.replace(/(___\d+___)|(##\$\$##)|(______)/g,(s,i)=>{
      repNum++
      return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
    })
    s = s.replace(/\#\#\$\$\#\#/g,(s,i)=>{
      repNum++
      return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
    })
    return s
  }
}

export function arrSortToString(arr, sort = false) {
  let str = ''
  if (!sort) {
    arr.forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  } else {
    arr.sort().forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  }

  return str
}
export function answerFormat(item) {
  let str = ''
  let len = item.length
    if(item.length > 1){
      item.forEach((val, index) => {
        str += val.content + ((index + 1) == len ? '; ' : ',&nbsp;')
      })
    }else {
      str += item[0].content + ';'
    }
  return htmlDecodeByRegExp(str.slice(0, -1))
}

export function getQueryString(name) {
  var search = window.location.href.split('?')[1]
  if (search) {
    var params = search.split('&')
    var obj = {}

    for (var i = 0, l = params.length; i < l; i++) {
      var tmp = params[i].split('=')
      obj[tmp[0]] = tmp[1]
    }

    return obj[name] || "";
  }
  return ""
}

export function rem(win) {
  function resize() {
    var domWidth = domEle.getBoundingClientRect().width;
    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }
    win.rem = domWidth / 16;
    domEle.style.fontSize = win.rem + "px";
  }
  var v, initial_scale, timeCode, dom = win.document,
    domEle = dom.documentElement,
    viewport = dom.querySelector('meta[name="viewport"]'),
    flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    var o = viewport.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else if (flexible) {
    var o = flexible.getAttribute("content").match(/initial\-dpr=(["']?)([\d\.]+)\1?/);
    if (o) {
      v = parseFloat(o[2]);
      initial_scale = parseFloat((1 / v).toFixed(2))
    }
  }
  if (!v && !initial_scale) {
    var n = (win.navigator.appVersion.match(/android/gi), win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    v = n ? v >= 3 ? 3 : v >= 2 ? 2 : 1 : 1, initial_scale = 1 / v
  }
  //没有viewport标签的情况下
  if (domEle.setAttribute("data-dpr", v), !viewport) {
    if (viewport = dom.createElement("meta"), viewport.setAttribute("name", "viewport"), viewport.setAttribute("content", "initial-scale=" + initial_scale + ", maximum-scale=" + initial_scale + ", minimum-scale=" + initial_scale + ", user-scalable=no"), domEle.firstElementChild) {
      domEle.firstElementChild.appendChild(viewport)
    } else {
      var m = dom.createElement("div");
      m.appendChild(viewport), dom.write(m.innerHTML)
    }
  }
  win.dpr = v;
  win.addEventListener("resize", function () {
    clearTimeout(timeCode), timeCode = setTimeout(resize, 300)
  }, false);
  win.addEventListener("pageshow", function (b) {
    b.persisted && (clearTimeout(timeCode), timeCode = setTimeout(resize, 300))
  }, false);
  resize();
}

export function isArray(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]') {
    return true
  }
  return false
}

export function isObject(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object object]') {
    return true
  }
  return false
}

export function isString(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object string]') {
    return true
  }
  return false
}

export function showErrMessage(e, msg) {
  let m = ''

  if (isObject(e)) {
    m = errorCode[e.code] ? e.msg : '网络错误'
  } else {
    m = msg
  }

  if(typeof m != 'undefined'){
    Message({
      message: m,
      type: 'error',
      duration: 3 * 1000
    })
  }
  console.log(msg)
  console.log(e)
}

export function isM3u8(url) {
  return /\.m3u8$/.test(url)
}

export function getVideoSourceOption(url) {
  let sourceObj = {}
  if (isM3u8(url)) {
    sourceObj = {
      type: 'application/x-mpegURL'
    }
  } else {
    sourceObj = {
      type: 'video/mp4'
    }
  }

  return Object.assign({}, sourceObj, {
    src: url
  })
}

export function debounce(func, wait, immediate) {

  var timeout;

  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}

export function isAndroid() {
  let res;
  if (/(Android)/i.test(navigator.userAgent)) {
    // 安卓机
    res = true;
  } else {
    res = false
  }
  return res;
}

export function isPkgCode(code){
  return [8930003, 8930004, 8930005, 8930006, 8930007].includes(code)
}

// 判断设备类型
export function userAgentType (){
	var ua = navigator.userAgent,
	isWindowsPhone = /(?:Windows Phone)/.test(ua),
	isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
	isAndroid = /(?:Android)/.test(ua),
	isFireFox = /(?:Firefox)/.test(ua),
	isChrome = /(?:Chrome|CriOS)/.test(ua),
	isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
	isPhone = /(?:iPhone)/.test(ua) && !isTablet,
	isPc = !isPhone && !isAndroid && !isSymbian;
	return {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc
	};
}

// 提示框 倒计时
export function countDownMessage(msg){
  let num = 3
  Message({
    message: msg.pre + num + msg.next,
    type: 'error',
    duration: 3 * 1000
  })

  let timer = setInterval(() => {
    if (num === 0) {
      clearInterval(timer)
    }
    --num
    $('.el-message__content').html(`${msg.pre + num + msg.next}`)
  }, 1000)
}

export function uniqueArrary(arr) {//数组的去重
  const res = new Map();
  return arr.filter((a) => !res.has(a) && res.set(a, 1))
}

export function getModuleName(code) {
  const curModule = {
    TEST_MODULE: {
      key: 3,
      value: '测试'
    },
    STUDY_MODULE: {
      key: 2,
      value: '学习'
    },
    RESTUDY_MODULE: {
      key: 1,
      value: '重学'
    },
    REVIEW_MODULE: {
      key: 4,
      value: '复习'
    },
    TEST_CHECK_MODULE: {
      key: 5,
      value: '补漏测'
    },
    STUDY_CHECK_MODULE: {
      key: 6,
      value: '补漏学'
    },
    SECTION_OVER: {
      key: 7,
      value: '章节结束'
    },
    SURFACE_RESTUDY_MODULE: {
      key: 1,
      value: '重学'
    },
    SURFACE_TEST_MODULE: {
      key: 5,
      value: '补漏测'
    },
    SURFACE_STUDY_MODULE: {
      key: 6,
      value: '补漏学'
    }
  }
  return curModule[code]
}
/*
** 添加移除class类
**/
export function addClass(element, className) {
  if(!new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className)) element.className += ' ' + className;
}
export function removeClass(element, className) {
  element.className = element.className.replace(new RegExp("(^|\\s)" + className + "(?=(\\s|$))", "g"), '');
}
export function getPercentTime(time){
  let m = Math.floor(time / 60)
  let s = time - m * 60
  return m + '分' + s + '秒';
}

export function userAnswerFormat(arr) {
  let str = ''
  arr.slice().forEach(item => {
    str += '\\[ '+item.content + '\\]' +';'
  })
  return str
}

// 判断是松鼠AI APP
export function isSSAI () {
  return /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent)
}

// 判断是否在移动端
export function isMobile () {
  return /Android|webOS|iPhone|iPod|BlackBerry|iPad|iOS/i.test(navigator.userAgent);
}

// 人脸采集数据
export function sdkFaceAcquisition(params) {
  console.log('人脸采集数据params=='+JSON.stringify(params))
  if (typeof(SSAICSDK) != 'undefined' && SSAICSDK.business) {
    let UserInfo = JSON.parse(localStorage.getItem("UserInfo"));
    let account_id = UserInfo['accountId'];
    let user_id = UserInfo['userId'];
    let course_id = UserInfo['courseId'];
    let lesson_id = UserInfo['lessonId'];
    let study_card_id = UserInfo['studyCardId'];
    let { module, study_activity, tag_code, question_id, video_id } = params;
    let actionsParams = {
      account_id: account_id,
      user_id: user_id,
      actions: {
        app_type: 'V2_MATH2', 
        user_id: user_id,
        subject_id: 2,
        course_id: course_id,
        lesson_id: lesson_id,
        study_card_id: study_card_id,
        module: module,
        timestamp: new Date().getTime(),
        tag_code: tag_code,
        study_activity: study_activity
      }
    }
    if (study_activity == 'VIDEO') { // 看视频
      actionsParams['actions']['video_id'] = video_id;
    } else { // 答题、查看解析
      actionsParams['actions']['question_id'] = question_id;
    }
    SSAICSDK.business.study.setActions(actionsParams);
    console.log('执行人脸采集了，采集的参数如下', JSON.stringify(actionsParams))
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js